// extracted by mini-css-extract-plugin
export default {"container":"content_container__ONPdv","wrapper":"content_wrapper__YSgD8"};